module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M24 2c0-1.106-.894-2-2-2H10C8.894 0 8 .894 8 2v6H2c-1.106 0-2 .894-2 2v20c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V10c0-1.106-.894-2-2-2h-6V2zM12 4h8v4h-8V4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/suitcase-1.js
// module id = 1438
// module chunks = 14